import { AjaxFetchConfig } from '@gaming1/g1-network';

export const COMMON_PRISMIC_AJAX_CONFIG: AjaxFetchConfig = {
  crossDomain: true,
  method: 'GET',
  headers: { Accept: 'application/json' },
};
